import { router } from '@/lego/config/router';

export function notifyRoute(route = null) {
  const path = route ?? router.currentRoute.path;

  if (router.currentRoute.path !== path) {
    router.push(path.startsWith('/') ? path : '/' + path);
  }
}

export function replaceRoute(route) {
  const path = route ?? router.currentRoute.path;

  if (router.currentRoute.path !== path) {
    router.replace(path.startsWith('/') ? path : '/' + path);
  }
}
